// src/context/ConfirmationContext.js

import React, { createContext, useState, useContext, useCallback } from 'react';
import ConfirmationDialog from '../tracker/components/ConfirmationDialog';

const ConfirmationContext = createContext();

export const ConfirmationProvider = ({ children }) => {
    const [options, setOptions] = useState({ open: false, title: '', message: '' });
    // We use a 'resolver' to be able to await the user's choice (Confirm or Cancel)
    const [resolve, setResolve] = useState(null);

    const confirm = useCallback((options) => {
        return new Promise((resolve) => {
            setOptions({ ...options, open: true });
            setResolve(() => resolve); // Store the resolve function
        });
    }, []);

    const handleClose = () => {
        if (resolve) resolve(false); // Resolve the promise with 'false'
        setOptions({ ...options, open: false });
    };

    const handleConfirm = () => {
        if (resolve) resolve(true); // Resolve the promise with 'true'
        setOptions({ ...options, open: false });
    };

    return (
        <ConfirmationContext.Provider value={confirm}>
            {children}
            <ConfirmationDialog
                open={options.open}
                options={options}
                onCancel={handleClose}
                onConfirm={handleConfirm}
            />
        </ConfirmationContext.Provider>
    );
};

// The custom hook we will use in our components
export const useConfirmation = () => useContext(ConfirmationContext);